export enum EventPaymentMethod {
    TRACEY = 1,
    ORGANISER = 2
}